"use client";

import { useTranslation } from "react-i18next";
import Input from "@/components/library/Input";
import Modal from "@/components/library/Modal";
import type { UnifiedIntegration } from "@/types/integrations";

interface IntegrationAgencyConnectionModalProps {
  open: boolean;
  agencyTarget: UnifiedIntegration | null;
  username: string;
  password: string;
  isConnecting: boolean;
  onUsernameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export default function IntegrationAgencyConnectionModal({
  open,
  agencyTarget,
  username,
  password,
  isConnecting,
  onUsernameChange,
  onPasswordChange,
  onSave,
  onCancel,
}: IntegrationAgencyConnectionModalProps) {
  const { t } = useTranslation("partners");
  const { t: ct } = useTranslation("common");

  return (
    <Modal
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel();
      }}
      header={{
        title: agencyTarget
          ? t("marketplaceSetup", { name: agencyTarget.name })
          : t("marketplaceIntegrationSetup"),
        description: agencyTarget
          ? t("marketplaceConfigureNamed", { name: agencyTarget.name })
          : t("marketplaceConfigureGeneric"),
      }}
      size="md"
      buttons={[
        {
          type: "primary",
          onClick: onSave,
          disabled: !username || !password || isConnecting,
          children: isConnecting
            ? t("marketplaceConnecting")
            : t("marketplaceConnect"),
        },
        {
          type: "secondary",
          onClick: onCancel,
          children: ct("cancel"),
        },
      ]}
    >
      <div className="space-y-4">
        <Input
          type="text"
          label={t("marketplaceUsername")}
          value={username}
          onChange={(e) => onUsernameChange(e.target.value)}
          autoComplete="off"
        />
        <Input
          type="password"
          label={t("marketplacePassword")}
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          autoComplete="off"
        />
      </div>
    </Modal>
  );
}
